<div
  class="page-container"
  [ngStyle]="{
    '--color50':
      seminarCategory?.color50 ?? seminarDateSeries.category1.color50,
    '--color0': seminarCategory?.color0 ?? seminarDateSeries.category1.color0,
    '--color70':
      seminarCategory?.color70 ?? seminarDateSeries.category1.color70,
    '--color80':
      seminarCategory?.color80 ?? seminarDateSeries.category1.color80,
    '--color90':
      seminarCategory?.color90 ?? seminarDateSeries.category1.color90,
  }">
  <div class="course-title background-transparent justify-space-between">
    <span class="font-bold-display-medium">
      {{ seminarDateSeries.seminar.title }}
    </span>
    @if (isAdmin) {
      <button class="inwi-text-button-medium-outline" (click)="editSeminar()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-pen"></i>
          </div>
          <div class="button-text">Bearbeiten</div>
        </div>
      </button>
    }
  </div>
  <div class="course-container">
    <div class="general-wrapper">
      <div class="general-information">
        <div class="general-information-header">
          <span class="font-medium-headline-large">
            Allgemeine Informationen
          </span>
          @if (seminarDateSeries?.seminar?.isCanceled) {
            <div class="inwi-chip-text-red-outline">Abgesagt</div>
          } @else {
            <div
              [class]="
                {
                  green: 'inwi-chip-text-green-outline',
                  yellow: 'inwi-chip-text-yellow-outline',
                  red: 'inwi-chip-text-red-outline',
                }[getSeminarOccupancyColor(seminarDateSeries)]
              ">
              {{ getFreeSeatsText(seminarDateSeries) }}
            </div>
          }
        </div>
        <div class="flex-c">
          <span class="font-medium-title-large font-color-black">
            Empfehlenswert für:
          </span>
          <span
            class="font-regular-body-large font-color-black pre-line break-word">
            {{ seminarDateSeries.seminar.recommendation }}
          </span>
        </div>
        <div class="flex-c">
          <span class="font-medium-title-large font-color-black">
            Voraussetzung:
          </span>
          <span
            class="font-regular-body-large font-color-black pre-line break-word">
            {{
              !seminarDateSeries.seminar.requirement ||
              seminarDateSeries.seminar.requirement === ''
                ? 'Keine'
                : seminarDateSeries.seminar.requirement
            }}
          </span>
        </div>
        <div class="flex-c font-color-black">
          <span class="font-medium-title-large"> Ort: </span>
          @if (seminarDateSeries.seminar.modality === 'online') {
            <div class="flex-c gap-16">
              <div class="flex-r align-center gap-16">
                <span>Online</span>
                <i class="fa-regular fa-globe font-color-black fa-xl"></i>
              </div>
              @if (isRegistered() || isAdmin) {
                <div class="flex-c gap-8">
                  @if (seminarDateSeries.seminar.link) {
                    <span>Link zum Meeting:</span>
                    <a
                      class="course-link"
                      href="{{ seminarDateSeries.seminar.link }}"
                      target="_blank">
                      Hier geht's zum Seminar-Raum
                    </a>
                  }
                  @if (
                    seminarDateSeries.seminar.platform &&
                    seminarDateSeries.seminar.meetingId &&
                    seminarDateSeries.seminar.meetingPassword
                  ) {
                    <div
                      class="online-meeting-credentials"
                      aria-label="Zugangsdaten zum Online-Seminar">
                      <div class="credential-row">
                        <i
                          class="fa-regular fa-video credential-icon"
                          aria-hidden="true"></i>
                        <div class="credential-body">
                          <span class="credential-label">Plattform</span>
                          <span class="credential-value break-word">{{
                            seminarDateSeries.seminar.platform
                          }}</span>
                        </div>
                      </div>
                      <div class="credential-row">
                        <i
                          class="fa-regular fa-hashtag credential-icon"
                          aria-hidden="true"></i>
                        <div class="credential-body">
                          <span class="credential-label">Seminar-ID</span>
                          <div class="credential-value-row">
                            <span
                              class="credential-value credential-value-mono break-word"
                              >{{ seminarDateSeries.seminar.meetingId }}</span
                            >
                            <button
                              type="button"
                              class="credential-copy-btn"
                              [class.credential-copy-btn--copied]="
                                copiedCredentialKind === 'id'
                              "
                              (click)="
                                copyMeetingCredential(
                                  seminarDateSeries.seminar.meetingId,
                                  'id'
                                )
                              "
                              [attr.aria-label]="
                                copiedCredentialKind === 'id'
                                  ? 'Seminar-ID wurde kopiert'
                                  : 'Seminar-ID kopieren'
                              ">
                              <i
                                class="fa-regular"
                                [class.fa-check]="copiedCredentialKind === 'id'"
                                [class.fa-copy]="copiedCredentialKind !== 'id'"
                                aria-hidden="true"></i>
                              <span class="credential-copy-btn-label">{{
                                copiedCredentialKind === 'id'
                                  ? 'Kopiert'
                                  : 'Kopieren'
                              }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="credential-row">
                        <i
                          class="fa-regular fa-lock-keyhole credential-icon"
                          aria-hidden="true"></i>
                        <div class="credential-body">
                          <span class="credential-label">Seminar-Kennwort</span>
                          <div class="credential-value-row">
                            <span
                              class="credential-value credential-value-mono break-word"
                              >{{
                                seminarDateSeries.seminar.meetingPassword
                              }}</span
                            >
                            <button
                              type="button"
                              class="credential-copy-btn"
                              [class.credential-copy-btn--copied]="
                                copiedCredentialKind === 'password'
                              "
                              (click)="
                                copyMeetingCredential(
                                  seminarDateSeries.seminar.meetingPassword,
                                  'password'
                                )
                              "
                              [attr.aria-label]="
                                copiedCredentialKind === 'password'
                                  ? 'Seminar-Kennwort wurde kopiert'
                                  : 'Seminar-Kennwort kopieren'
                              ">
                              <i
                                class="fa-regular"
                                [class.fa-check]="
                                  copiedCredentialKind === 'password'
                                "
                                [class.fa-copy]="
                                  copiedCredentialKind !== 'password'
                                "
                                aria-hidden="true"></i>
                              <span class="credential-copy-btn-label">{{
                                copiedCredentialKind === 'password'
                                  ? 'Kopiert'
                                  : 'Kopieren'
                              }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          } @else {
            <div class="flex-r align-center gap-16 align-self-stretch">
              <div class="flex-c font-color-black">
                <span class="font-bold-body-large">
                  {{ seminarDateSeries.seminar.address?.title }}
                </span>
                <span class="font-regular-body-large">
                  {{ seminarDateSeries.seminar.address?.street }}
                  {{ seminarDateSeries.seminar.address?.houseNumber }}
                </span>
                <span class="font-regular-body-large">
                  {{ seminarDateSeries.seminar.address?.zip }}
                  {{ seminarDateSeries.seminar.address?.city }}
                </span>
              </div>
              <i class="fa-regular fa-location-dot font-color-black fa-xl"></i>
            </div>
          }
        </div>
        <div class="flex-c">
          <span class="font-medium-title-large font-color-black">
            Fachbereich:
          </span>
          <span class="font-regular-body-large font-color-black">
            {{ seminarDateSeries.category1.name
            }}{{
              seminarDateSeries.category2
                ? ', ' + seminarDateSeries.category2.name
                : ''
            }}
          </span>
        </div>
      </div>
      <div class="lecturer-information">
        <div class="lecturer-information-content">
          <div
            class="lecturer-avatar"
            [class.avatar-small]="seminarDateSeries.lecturer2 != null">
            <app-avatar
              placeholderBackgroundColor="#EEF3EB"
              [placeholderColor]="
                seminarCategory?.color0 ?? seminarDateSeries.category1.color0
              "
              [user]="seminarDateSeries.lecturer1"></app-avatar>
          </div>

          <div class="lecturer-informations">
            <span class="font-medium-headline-small">
              {{ getUserFullName(seminarDateSeries.lecturer1) }}
            </span>
            @if (seminarDateSeries.lecturer1?.jobTitle) {
              <span class="font-regular-body-large font-color-black">
                {{ seminarDateSeries.lecturer1.jobTitle }}
              </span>
            }
            @if (seminarDateSeries.lecturer1?.description1) {
              <span class="font-regular-body-large font-color-black">
                {{ seminarDateSeries.lecturer1.description1 }}
              </span>
            }
            @if (seminarDateSeries.lecturer1?.description2) {
              <span class="font-regular-body-large font-color-black">
                {{ seminarDateSeries.lecturer1.description2 }}
              </span>
            }
            @if (seminarDateSeries.lecturer1?.description3) {
              <span class="font-regular-body-large font-color-black">
                {{ seminarDateSeries.lecturer1.description3 }}
              </span>
            }
          </div>
        </div>
        <button
          type="button"
          (click)="viewLecturerVita(seminarDateSeries.lecturer1.id)"
          class="inwi-icon-text-button-medium-outline border-none align-self-stretch">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-sparkle"></i>
            </div>
            <div class="button-text">Zur vollständigen Vita</div>
          </div>
        </button>
        @if (seminarDateSeries.lecturer2 != null) {
          <div class="lecturer-divider"></div>
          <div class="lecturer-information-content">
            <div
              class="lecturer-avatar"
              [class.avatar-small]="seminarDateSeries.lecturer2 != null">
              <app-avatar
                placeholderBackgroundColor="#EEF3EB"
                [placeholderColor]="
                  seminarCategory?.color0 ?? seminarDateSeries.category1.color0
                "
                [user]="seminarDateSeries.lecturer2"></app-avatar>
            </div>
            <div class="lecturer-informations">
              <span class="font-medium-headline-small">
                {{ getUserFullName(seminarDateSeries.lecturer2) }}
              </span>
              @if (seminarDateSeries.lecturer2?.jobTitle) {
                <span class="font-regular-body-large font-color-black">
                  {{ seminarDateSeries.lecturer2.jobTitle }}
                </span>
              }
              @if (seminarDateSeries.lecturer2?.description1) {
                <span class="font-regular-body-large font-color-black">
                  {{ seminarDateSeries.lecturer2.description1 }}
                </span>
              }
              @if (seminarDateSeries.lecturer2?.description2) {
                <span class="font-regular-body-large font-color-black">
                  {{ seminarDateSeries.lecturer2.description2 }}
                </span>
              }
              @if (seminarDateSeries.lecturer2?.description3) {
                <span class="font-regular-body-large font-color-black">
                  {{ seminarDateSeries.lecturer2.description3 }}
                </span>
              }
            </div>
          </div>
          <button
            type="button"
            (click)="viewLecturerVita(seminarDateSeries.lecturer2.id)"
            class="inwi-icon-text-button-medium-outline border-none align-self-stretch">
            <div class="button-content">
              <div class="button-icon">
                <i class="fa-regular fa-sparkle"></i>
              </div>
              <div class="button-text">Zur Vollständigen Vita</div>
            </div>
          </button>
        }
      </div>
    </div>
    @if (sponsorCardsLoading && seminarDateSeries.sponsorCardIds?.length > 0) {
      <div class="flex-r justify-center align-self-stretch">
        <p-skeleton width="670px" height="106px"></p-skeleton>
      </div>
    } @else if (sponsorCards && sponsorCards.length > 0) {
      <app-sponsor-card [sponsorCards]="sponsorCards"></app-sponsor-card>
    }
    <div class="course-content-information">
      <span class="font-medium-headline-large"> Kursinhalte </span>
      <div class="flex-c w-full">
        <span class="font-medium-title-large font-color-black">
          Beschreibung:
        </span>
        <span
          class="font-regular-body-large font-color-black pre-line break-word">
          {{ seminarDateSeries.seminar.description }}
        </span>
      </div>

      <div class="flex-c">
        <span class="font-medium-title-large font-color-black">
          Worum geht es
        </span>
        <span class="font-regular-body-large font-color-black pre-line">
          {{ seminarDateSeries.seminar.about }}
        </span>
      </div>

      <div class="flex-c">
        <span class="font-medium-title-large font-color-black"> Ziele: </span>
        <span class="font-regular-body-large font-color-black pre-line">
          {{ seminarDateSeries.seminar.goals }}
        </span>
      </div>

      <div class="flex-c">
        <span class="font-medium-title-large font-color-black">
          Nutzen für die Praxis:
        </span>
        <span class="font-regular-body-large font-color-black pre-line">
          {{ seminarDateSeries.seminar.benefit }}
        </span>
      </div>
    </div>
    <div class="facts-information">
      <span class="font-medium-headline-large"> Fakten </span>
      <div class="facts-information-content">
        <div class="flex-c gap-16 align-start flex-1-1-0">
          <div class="flex-c align-self-stretch">
            <span class="font-medium-title-large font-color-black">
              Seminarnummer:
            </span>
            <span class="font-regular-body-large font-color-black">
              {{ seminarDateSeries.seminar.seminarNr }}
            </span>
          </div>

          <div class="flex-c align-self-stretch">
            <span class="font-medium-title-large font-color-black">
              Konditionen:
            </span>
            <div
              class="display-flex align-start gap-16 align-self-stretch padding-bottom-16">
              <div class="conditions-container">
                @for (
                  condition of seminarDateSeries.seminar.conditions;
                  track $index
                ) {
                  <span
                    class="condition-label font-regular-body-large font-color-black">
                    {{
                      condition.type === 'vdp'
                        ? 'VDP Mitglied'
                        : condition.type === 'vdb'
                          ? 'VDB Mitglied'
                        : condition.type === 'early'
                          ? 'Frühbucher'
                          : condition.type === 'bed'
                            ? 'BED Mitglied'
                            : condition.type === 'office'
                              ? 'Praxis (ab 3 Personen)'
                              : condition.type === 'logo'
                                ? 'LOGO Deutschland Mitglied'
                                : 'Regulär'
                    }}{{
                      condition.date
                        ? ' (bei Buchung bis ' +
                          (condition.date | date: 'dd.MM.yyyy') +
                          ')'
                        : ''
                    }}
                  </span>
                  <span
                    class="condition-value font-bold-body-large font-color-black">
                    {{ condition.price | currency: 'EUR' }}
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="flex-c gap-16 align-start flex-1-1-0">
          @if (seminarDateSeries.seminar.fobiPoints) {
            <div class="flex-c align-self-stretch">
              <span class="font-medium-title-large font-color-black">
                Fobipunkte:
              </span>
              <span class="font-regular-body-large font-color-black">
                {{ getSeminarFobiPoints(seminarDateSeries) }} FP ({{
                  getSeminarFobiPoints(seminarDateSeries)
                }}
                UE)
              </span>
            </div>
          } @else {
            <div class="flex-c align-self-stretch">
              <span class="font-medium-title-large font-color-black">
                Unterrichtseinheiten:
              </span>
              <span class="font-regular-body-large font-color-black">
                {{ getSeminarUE(seminarDateSeries) }}
                UE
              </span>
            </div>
          }
          <div class="flex-c align-self-stretch">
            <span class="font-medium-title-large font-color-black">
              Datum und Uhrzeit:
            </span>
            <div class="flex-c align-start gap-4">
              <div class="flex-c">
                <span class="font-medium-body-large font-color-black">
                  {{ seminarDateSeries.dateSeriesName }}
                </span>
                @for (date of seminarDateSeries.dates; track $index) {
                  <span class="font-regular-body-large font-color-black">
                    {{ date.startDate | date: 'EEE, dd.MM.yyyy HH:mm' }} -
                    {{ date.endDate | date: 'HH:mm' }}
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-c align-self-stretch">
        <span class="font-medium-title-medium font-color-black">
          {{ seminarDateSeries.seminar.additionsTitle }}
        </span>
        <span class="font-regular-body-medium font-color-black pre-line">
          {{ seminarDateSeries.seminar.additionsDescription }}
        </span>
      </div>
    </div>
    @if (isRegistered() || isAdmin) {
      <app-file-manager
        [seminarId]="seminarDateSeries.seminar.id"
        [seminarCategory]="seminarCategory || seminarDateSeries.category1"
        [listView]="listView"
        [isAdminView]="false"
        [allowUpload]="false"
        [allowDelete]="false"></app-file-manager>
    }
  </div>
</div>
